(function () {
  function activateSizeGuidePanel(panelId) {
    if (!panelId) return;
    var tabs = document.querySelectorAll('.sg-tab-btn');
    var panels = document.querySelectorAll('.sg-panel');
    var images = document.querySelectorAll('.sg-dynamic-image');
    tabs.forEach(function (tab) {
      tab.classList.toggle('is-active', tab.getAttribute('data-sg-target') === panelId);
    });
    panels.forEach(function (panel) {
      panel.classList.toggle('is-active', panel.id === panelId);
    });
    images.forEach(function (img) {
      img.classList.toggle('is-active', img.id === panelId + '-img');
    });
  }

  function resolveInitialPanel(triggerEl) {
    if (triggerEl) {
      var fromBtn = triggerEl.getAttribute('data-initial-panel');
      if (fromBtn) return fromBtn;
    }
    var modal = document.getElementById('SizeGuideModal');
    if (modal && modal.dataset.defaultPanel) return modal.dataset.defaultPanel;
    if (triggerEl) {
      var productInfo = triggerEl.closest('product-info');
      if (productInfo && productInfo.dataset.sizeGuidePanel) {
        return productInfo.dataset.sizeGuidePanel;
      }
    }
    return 'sg-rings';
  }

  function openSizeGuide(initialPanel, triggerEl) {
    var modal = document.getElementById('SizeGuideModal');
    if (!modal) return;
    var panel = initialPanel || resolveInitialPanel(triggerEl);
    if (panel) activateSizeGuidePanel(panel);
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeSizeGuide(modal) {
    if (!modal) modal = document.getElementById('SizeGuideModal');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  window.VennassaSizeGuide = {
    open: openSizeGuide,
    close: closeSizeGuide,
    activatePanel: activateSizeGuidePanel,
  };

  function bindTriggers() {
    document.querySelectorAll('.size-guide-trigger-btn').forEach(function (btn) {
      if (btn.dataset.sgBound === 'true') return;
      btn.dataset.sgBound = 'true';
      btn.addEventListener('click', function () {
        openSizeGuide(btn.getAttribute('data-initial-panel'), btn);
      });
    });
  }

  function bindModal() {
    var modal = document.getElementById('SizeGuideModal');
    if (!modal || modal.dataset.sgBound === 'true') return;
    modal.dataset.sgBound = 'true';

    modal.querySelectorAll('.venn-modal-close').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-close');
        closeSizeGuide(id ? document.getElementById(id) : modal);
      });
    });

    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeSizeGuide(modal);
    });

    document.querySelectorAll('.sg-tab-btn').forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateSizeGuidePanel(tab.getAttribute('data-sg-target'));
      });
    });
  }

  function init() {
    bindModal();
    bindTriggers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
